import { render, staticRenderFns } from "./DiagnosticAssistance.vue?vue&type=template&id=6237ebde&scoped=true&"
import script from "./DiagnosticAssistance.vue?vue&type=script&lang=ts&"
export * from "./DiagnosticAssistance.vue?vue&type=script&lang=ts&"
import style0 from "./DiagnosticAssistance.vue?vue&type=style&index=0&id=6237ebde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6237ebde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VForm,VIcon,VSnackbar,VSpeedDial,VTextField,VTooltip})
